import React from "react";
import "./Profile.css";

import bg from "../../Images/Background/henrik-donnestad-splash.png";

export default function Profile() {
  return (
    <>
      <div className="profile-container">
        <div className="prf-win">
          <div className="prf-box">
            <div className="head-prf">ABOUT ME</div>
            <div className="prf-desc">
              <div>
                <h2>Sup! I am Starman, aka</h2>
                <div className="fancy-name"> idhant dabral</div>
                <h2 className="subline">
                  {" "}
                  and here is a little bit about me . . .
                </h2>
                <p className="prf-full">
                  <div>
                  <p>3 words. </p>
                  <p>Gameplay </p>
                  <p>Gameplay </p>
                  <p>Gameplay Programmer </p>
                  <p>We're talking about the third one today. Allow me to tell you a story. </p>
                  <p>(I'll write something more proffesional next time, I promise)</p>
                  
                  <p>The
                  year? 2000 Its been a year since Phantom Menace. Majora's mask
                  came out half a year ago. Tony Hawk's Pro Skater II just hit
                  the shelves.</p> 
                  
                  <p>Following those two greats of gaming, was yet
                  another international gem, yours truly. And yeah, there was
                  Counter Strike but we dont talk about that. Patched as a tank
                  in our world's game in the chilly part of north India, I was
                  introduced to the current roster to add more flavor, more
                  charm, and of course, more humor. Rigourously trained in a
                  bachelor's degree under the I.T. sect. </p>
                  
                  <p>As a Gameplay
                  Programming disciple, I love to work closely with designers to
                  create memorable and fun experiences that can evoke the same
                  emotions that games did for me. </p>
                  
                  <p>Oh, you know the ones. As you
                  peer down a cliffside and the vast world of Hyrule streches
                  out to you, as you execute that perfect combo to win your
                  lane, and when you dive deep into the meaty parts of the
                  ever-expanding lore that studios put in thier games. </p>
                  
                  <p>Those
                  emotions.</p>
                  </div>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
